
// src/components/landing/AssistantTeaserSection.tsx
"use client";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import Image from "next/image";

export function AssistantTeaserSection() {
  return (
    <section className="py-16 md:py-24 bg-muted/30">
      <div className="container mx-auto px-4 flex justify-center">
        <Card className="max-w-2xl w-full shadow-lg border-none bg-white">
          <CardHeader className="items-center text-center">
             <Image src="/zamzi-icon.svg" alt="AI Assistant Icon" width={60} height={60} />
            <CardTitle className="text-2xl font-bold text-primary mt-2">
              Ask why Zamzi Connect helps South Africans get found online
            </CardTitle>
            <CardDescription className="text-md text-muted-foreground max-w-lg">
              Ask our AI Assistant about discoverability, booking tools, profile visibility, AI-ready positioning, and how Zamzi helps businesses and professionals become easier to find, trust, and choose.
            </CardDescription>
          </CardHeader>
          <CardContent className="flex justify-center">
            <Button asChild size="lg" style={{ backgroundColor: "#ffb81c", color: "white" }}>
              <Link href="/chat">
                Ask About Our Benefits
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </section>
  );
}
